import { DefaultTheme } from "styled-components";

const DIGIPOSTHEME: DefaultTheme = {
  colors: {
    light: "#2179be",
    primaryBlack: "#000000",
    secondary: "#FF8400",
    secondaryDark: "#FA6C00",
    white: "#ffffff",
    red: "#EB212E",
    transparent: "transparent",
    grey: "#5d586429",
    darkGrey: "#5A5A5A",
    cherryRed: "#BC1A25",
    strawberryRed: "#C81C27",
    headerRed: "#DC0005",
    whiteGrey: "rgba(255, 255, 255, 0)",
    black: "rgba(51, 51, 51, 0.85)",
    tableButtonShadow: "#132337ba",
    sourCherryRed: "#8d1a1f",
    footerGrey: "#e0e0e0",
    secondaryBlack: "#202020",
    secondaryGrayTertiary: "#e6e5e9",
    darkBurgundy: "#810c04",
    secondaryWhite: "#f5f4f6",
    darkBlack: " #383241;",
    secondaryOffWhite: "#f5f4f6",
    validationError: "#ff6e64",
    secondaryGrayPrimary: "#5d5864",
    secondaryGraySecondary: "#a6a1ad",
    secondaryGrayTertinary: "#e6e5e9",
    secondaryAkbankBlack: "#202020",
    primaryAkbankWhite: "#ffffff",
    primaryAkbankRed: "#dc0005",
    secondaryAkbankWhite: "#f8f8f8",
    inputBorder: "#e6e5e9",
    paginationBackground: "#f9f9f9",
    secondaryGrey: "#e7e7e7",
    avatarMenuShadow: "#cbd5d7",
    avatarMenuBottomShadow: "#e6e5e9",
    avatarFocusShadow: "#00000029",
    primaryToggleGreen: "#6cc36c",
    orange: "#ffad33",
  },
  fonts: {
    size: "100px",
  },
};

export { DIGIPOSTHEME };
